var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-container"},[_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }